<h1 class="text-center mt-4" *ngIf="!loaded">Validando token...</h1>
<h1 class="text-center mt-4" *ngIf="loaded">Token expirado ou inválido. Tente novamente.</h1>
